import { ClickwrapTemplatePlaceholders } from "./models";

export class ClickwrapError extends Error {
  constructor(message: string, readonly original: any = null) {
    super(message);
  }
}


export function normalizeTemplatePlaceholders(
  templatePlaceholders?: ClickwrapTemplatePlaceholders | null
): ClickwrapTemplatePlaceholders | null {
  if (!templatePlaceholders) {
    return null
  }

  const normalized: ClickwrapTemplatePlaceholders = {};

  for (const [key, value] of Object.entries(templatePlaceholders)) {
    if (key === 'customPlaceholders') {
      continue;
    }

    if (value !== null && value !== undefined) {
      normalized[key as keyof Omit<ClickwrapTemplatePlaceholders, 'customPlaceholders'>] = value as string;
    }
  }

  if (templatePlaceholders.customPlaceholders) {
      const customPlaceholders = Object.fromEntries(
      Object.entries(templatePlaceholders.customPlaceholders).filter(
        ([, value]) => value !== null && value !== undefined
      )
    ) as Record<string, string>;

    normalized.customPlaceholders = customPlaceholders;
  }

  return normalized;
}